import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DocumentsPAC } from '@shared/model';
import { DateUtilities } from "@mynexus/mynexus-ui-lib";
import { debounce } from "lodash-es";

@Component({
    selector: 'documents-tab-pac',
    templateUrl: './documents-tab-pac.component.html',
    styleUrls: ['./documents-tab-pac.component.scss'],
    standalone: false
})
export class DocumentsTabPacComponent implements OnInit {
  @Input() authRequestReceivedDate!: string;
  @Input() documents: DocumentsPAC[];

  @Output() backStep = new EventEmitter<void>();
  @Output() cancelProcess = new EventEmitter<void>();
  @Output() submitStep = new EventEmitter<DocumentsPAC[]>();
  @Output() updateDocuments = new EventEmitter<DocumentsPAC[]>();

  noClinicalDocuments =  false;

  ngOnInit(): void {
    if (this.documents) {
      this.noClinicalDocuments = this.documents.length === 0;
    }
  }

  onClickBack(): void {
    this.backStep.emit();
  }

  onCancel(): void {
    this.cancelProcess.emit();
  }

  onSubmit(): void {
    this.submitDebounced();
  }

  private submitDebounced = debounce(() => {
    this.submitStep.emit(this.documents);
  }, 500);

  loadFiles(uploadedFiles: DocumentsPAC[]) {
    this.documents = uploadedFiles.length ? this.applyAuthDate(uploadedFiles) : null;

    this.updateDocuments.emit(this.documents);
  }

  onChangeNoClinicalDocumentsField(): void {
    if (this.noClinicalDocuments) {
      this.documents = [];
      this.updateDocuments.emit([]);
    }
  }

  private applyAuthDate(documents: DocumentsPAC[]): DocumentsPAC[] {
    return documents.map(document => {
      return {
        ...document,
        dateTimeFaxReceived: this.authRequestReceivedDate != null && DateUtilities.isDateValid(this.authRequestReceivedDate)
          ? this.authRequestReceivedDate : document.dateTimeFaxReceived
      };
    });
  }
}
